import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { notices } from '../data/notices';
import SubLayout from '../components/layout/SubLayout';
import { customerMenus } from '../data/customerMenus';

// 상세 페이지에서도 사이드바의 '공지사항'이 활성 표시되도록 목록 경로를 고정으로 넘긴다
const NOTICE_LIST_PATH = '/notices';

const Header = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.border};
  padding-bottom: 20px;
  margin-bottom: 30px;
`;

const Title = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 15px;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const Meta = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  color: ${props => props.theme.colors.textSub};
  font-size: 14px;
  margin-top: 10px;
  flex-wrap: wrap;

  .view-count-label {
    background: #f0f0f0;
    padding: 2px 8px;
    border-radius: 12px;
    font-weight: 600;
    color: ${props => props.theme.colors.primary};
  }
`;

const Content = styled.div`
  line-height: 1.9;
  min-height: 300px;
  white-space: pre-wrap;
  color: #444;
  font-size: 1rem;
`;

const Button = styled.button`
  margin-top: 50px;
  padding: 10px 25px;
  background: ${props => props.theme.colors.lightGray};
  border: 1px solid ${props => props.theme.colors.border};
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  &:hover { background: #eee; }
`;

const NotFound = styled.div`
  text-align: center;
  padding: 100px 0;
  color: #888;
  font-size: 1.1rem;
`;

const NoticeDetail = () => {
  const { noticeId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const fromPage = location.state?.fromPage || 1;

  const notice = notices.find(n => n.id === parseInt(noticeId));

  if (!notice) {
    return (
      <SubLayout
        title="공지사항"
        sidebarMenus={customerMenus}
        category="고객센터"
        categoryEn="Customer"
        activePath={NOTICE_LIST_PATH}
      >
        <NotFound>존재하지 않는 공지사항입니다.</NotFound>
        <div style={{ textAlign: 'center' }}>
          <Button onClick={() => navigate(`/notices?page=${fromPage}`)}>목록으로</Button>
        </div>
      </SubLayout>
    );
  }

  return (
    <SubLayout
      title="공지사항"
      sidebarMenus={customerMenus}
      category="고객센터"
      categoryEn="Customer"
      activePath={NOTICE_LIST_PATH}
    >
      <Header>
        <Title>{notice.title}</Title>
        <Meta>
          <span>작성일: {new Date(notice.created_at).toLocaleDateString()}</span>
          <span>
            <span className="view-count-label">조회수</span> {notice.view_count}
          </span>
        </Meta>
      </Header>
      <Content>{notice.content}</Content>
      <Button onClick={() => navigate(`/notices?page=${fromPage}`)}>목록으로</Button>
    </SubLayout>
  );
};

export default NoticeDetail;
